import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "lineItemNumber",
    "lineItem",
    "sliIdField",
    "netSubtotal",
    "passThroughCostInput",
    "passThroughCostBtn"
  ]
  static values = {
    savingsPercentSelector: String
  }

  connect() {
    this.resetLineNumbers();
    // Under the React island the rows (and their wholesaleSubtotal inputs) mount
    // after this controller connects — recomputing from an empty container would
    // overwrite the server-rendered total with $0.00 until the chunk loads. The
    // island dispatches proposal-line-price-changed on mount, which recomputes.
    if (this.element.querySelector('[data-proposal-li-target="wholesaleSubtotal"]')) {
      this.updateNetSubtotal();
    }
  }

  onCurrencyChange(event) {
    if (!event.target.matches('select.currency_type')) return;
    this.updateNetSubtotal();
  }

  lineItemTargetConnected() {
    this.lineItemsChanged();
  }

  lineItemTargetDisconnected() {
    this.lineItemsChanged();
  }

  lineItemsChanged() {
    this.resetLineNumbers();
    this.disableSavingsPercent(this.anySavedLineItemsUsed())
    this.updateNetSubtotal();
    if (this.hasPassThroughCostBtnTarget) {
      if (this.passThroughCostInputTargets.some((el) => el.value === "true")) {
        this.passThroughCostBtnTarget.classList.add("d-none");
      } else {
        this.passThroughCostBtnTarget.classList.remove("d-none");
      }
    }
    // dispatching rx:fieldAdded is this code pretending to act like the nested forms gem worked
    // as some old jquery code still relies on it
    // app/assets/javascripts/backoffice/controllers/quoted_wares.js:542
    this.dispatch("rx:fieldAdded", { prefix: false })
    setTimeout(() => {
      for (const element of document.querySelectorAll('.newly-added')) {
        element.classList.remove('newly-added')
      }
    }, 2000)
  }

  updateNetSubtotal() {
    if (!this.hasNetSubtotalTarget) return;

    let total = 0;

    // Find all wholesale subtotal inputs within this container
    const wholesaleSubtotals = this.element.querySelectorAll('[data-proposal-li-target="wholesaleSubtotal"]');
    wholesaleSubtotals.forEach((input) => {
      const value = parseFloat(input.value) || 0;
      total += value;
    });

    this.netSubtotalTarget.value = this.formatMoneyDisplay(total);
  }

  getCurrencyCode() {
    return document.querySelector('select.currency_type')?.value || 'USD';
  }

  formatMoneyDisplay(amount) {
    const currency = this.getCurrencyCode();
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
  }

  resetLineNumbers() {
    this.lineItemNumberTargets.forEach((target, index) => {
      target.textContent = index + 1
    });
  }

  disableSavingsPercent(hide) {
    const savingsPercentInput = document.querySelector(this.savingsPercentSelectorValue)
    if (savingsPercentInput) {
      if (hide) {
        savingsPercentInput.disabled = true
        savingsPercentInput.value = 0
        savingsPercentInput.style.backgroundColor = "#f0f0f0"
      } else {
        savingsPercentInput.disabled = false
        savingsPercentInput.style.backgroundColor = "#ffffff"
      }
    }
  }

  anySavedLineItemsUsed() {
    return this.sliIdFieldTargets.some(element => element?.value !== "")
  }
}
